module.exports = __webpack_public_path__ + "img/9_6.f0bab0c5.png";